import React from 'react'
import Table from '../../../../components/DataTable/Table'
import TableServer from '../../../../components/DataTable/TableServer'

const headCells = [
    //{ id: 'site', label: 'Site' },
    { id: 'nursery', label: 'Pépinière' },
    //{ id: 'date_purchase', label: 'Date', type: 'date' },
    { id: 'pot', label: 'Pots' },
    { id: 'objective', label: 'Objectif', type: 'Integer' },
    { id: 'quantity', label: 'Quantité rebouché', type: 'Integer' },
    { id: 'Nbr_empty_pot', label: 'Nombre de pot vide', type: 'Integer' },
    { id: 'Nbr_sown_pot', label: 'Nombre de pot semé', type: 'Integer' },
    {
        id: 'actions',
        type: 'actions',
        label: 'Actions',
        disableSorting: true,
        showEdit: false,
        showRemove: true
        // editPath: '/app/agroforestry/nursery/supply/recorged_pot/edit'
    }
]

function RecorgedPotList(props) {
    const {
        haveAccessTo,
        service,
        needLoad,
        currentPage,
        Form,
        drawer,
        setNeedLoad,
        filterFromList,
        activeCenterFromList,
        activeCenterComFromList,
        drawerTitle
    } = props
    return (
        <>
            <TableServer
                title={drawerTitle}
                headCells={headCells}
                service={service}
                haveAccessTo={haveAccessTo}
                needLoad={needLoad}
                setNeedLoad={setNeedLoad}
                currentPage={currentPage}
                Form={Form}
                drawer={drawer}
                hideFilterButton={true}
                showSiteButton={false}
                hideToolbar={false}
                filterFromList={filterFromList}
                activeCenterFromList={activeCenterFromList}
                activeCenterComFromList={activeCenterComFromList}
            />
        </>
    )
}

export default RecorgedPotList
